import { useEffect, useRef, useState } from 'react';
import { CmsMedia } from '../../data/cms';
import { imageUrl } from './Cms';

export default function ServiceHero({ media, title }: { media: CmsMedia; title: string }) {
  const [expanded, setExpanded] = useState(false);
  const dialog = useRef<HTMLDialogElement>(null);
  const trigger = useRef<HTMLButtonElement>(null);
  const url = imageUrl(media.url);
  const candidates = [media.formats?.small, media.formats?.medium, media.formats?.large, media]
    .filter((item): item is { url: string; width: number } => Boolean(item?.url && item?.width));
  const srcSet = Array.from(new Map(candidates.map(item => [item.width, `${imageUrl(item.url)} ${item.width}w`])).values()).join(', ');
  useEffect(() => {
    if (!expanded) return;
    dialog.current?.showModal();
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = overflow; };
  }, [expanded]);
  if (!url) return null;
  return <figure className="service-hero-figure">
    <img className="service-hero-image" src={url} srcSet={srcSet || undefined} sizes="(max-width: 600px) calc(100vw - 48px), (max-width: 1300px) 90vw, 1160px" width={media.width} height={media.height} alt={media.alternativeText || title} decoding="async" />
    <figcaption><span>{media.caption || '支援内容のイメージ'}</span><button ref={trigger} type="button" onClick={() => setExpanded(true)} aria-haspopup="dialog" aria-label={`${title}の画像を拡大`}>画像を拡大 <span aria-hidden="true">↗</span></button></figcaption>
    <dialog ref={dialog} className="service-image-dialog" aria-label={`${title}の拡大画像`} onClose={() => { setExpanded(false); trigger.current?.focus(); }} onClick={event => { if (event.target === event.currentTarget) dialog.current?.close(); }}>
      <div className="service-image-dialog-head"><p>{title}<small>画像は左右にスクロールして確認できます。</small></p><button type="button" autoFocus onClick={() => dialog.current?.close()} aria-label="拡大画像を閉じる">閉じる ×</button></div>
      <div className="service-image-scroll" tabIndex={0} role="region" aria-label="画像の詳細">{expanded && <img src={url} alt={media.alternativeText || title} />}</div>
    </dialog>
  </figure>;
}
